import React, { Fragment, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import Recaptcha from "react-recaptcha";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import i18n from "../../../i18n";
import Configuration from "../../../config";

export default function RecaptchaField(props) {
  const { errorText, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { summaryMode } = rest;
  const key =
    Configuration.get("REACT_APP_RECAPTCHA_KEY") ||
    "6Lcx7QkaAAAAAOZhGUqBpK8mMRFOZysGG8ZWyQWs";
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  const onVerifiedCallback = (response) => {
    setValue(response);
  };
  const reset = () => {
    setFieldValue(field.name, "");
  };
  const currentLanguage = i18n.language === "it-IT" ? "it-IT" : "en-US";

  return (
    <Form.Group className={meta.touched && meta.error ? "has-error" : ""}>
      {!summaryMode ? (
        <Fragment>
          <Recaptcha
            sitekey={key}
            render="explicit"
            theme="light"
            verifyCallback={onVerifiedCallback}
            hl={currentLanguage}
            onloadCallback={() => {
              console.log("done loading!");
            }}
            expiredCallback={reset}
          />
          {meta.touched && meta.error && (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
        </Fragment>
      ) : (
        <SummaryItem value={field.value} error={meta.error} />
      )}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
    </Form.Group>
  );
}
